export default __webpack_public_path__ + "media/copilotFreStep1.269a885e.webp";